export default "__VITE_ASSET__nHHp72DP__"